import { GoalType } from '../../graphql/generated';
import { useFinancialEntitiesContext } from '../financialEntities';
import { useCurrentUser } from '../user';

const ADD_GOAL_OPTIONS: GoalType[] = [
    'CASH_MANAGEMENT',
    'GENERAL_INVESTING',
    'CUSTOM',
    'RETIREMENT',
    'HOME_DOWN_PAYMENT',
    'EMERGENCY_FUND',
    'VACATION',
    'CAR',
    'WEDDING',
    'BABY',
    'DAYCARE',
];

const ONE_TIME_GOAL_TYPES: Set<GoalType> = new Set(['RETIREMENT' as const]);

export const useAddableGoalTypes = () => {
    const { featureFlags } = useCurrentUser();
    const { fes } = useFinancialEntitiesContext();

    // Exclude Retirement if feature flag is not enabled
    let addableTypes = featureFlags.isRetirementEnabled
        ? ADD_GOAL_OPTIONS
        : ADD_GOAL_OPTIONS.filter((t) => t !== 'RETIREMENT');

    // Hide certain goals if one already exists
    const existingOneTimeGoalTypes = new Set(
        fes.data?.goals
            .filter((g) => ONE_TIME_GOAL_TYPES.has(g.type))
            .map((g) => g.type)
    );

    addableTypes = addableTypes.filter((t) => !existingOneTimeGoalTypes.has(t));

    return { addableTypes };
};
